export const ADD_CHATROOM = 'ADD_CHATROOM'
export const SET_CHATROOMS = 'SET_CHATROOMS'
export const SET_CHATROOM = 'SET_CHATROOM'
export const SET_CURRENT_CHATROOM_USERS = 'SET_CURRENT_CHATROOM_USERS'
export const SET_ALL_USERS = 'SET_ALL_USERS'
export const ADD_USER_TO_CHATROOM = 'ADD_USER_TO_CHATROOM'
export const REMOVE_USER_FROM_CHATROOM = 'REMOVE_USER_FROM_CHATROOM'

export const DELETE_CHATROOM = 'DELETE_CHATROOM'
export const GET_CHATROOM = 'GET_CHATROOM'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const SAVE_AVATAR = 'SAVE_AVATAR'

export const SET_APPLICATION = 'SET_APPLICATION'
export const SET_APPLICATIONS = 'SET_APPLICATIONS'
export const SET_USER = 'SET_USER'
